<template>
  <div>
    <div class="row justify-content-end mb-3">
      <div class="col-auto">
        <button @click="refresh()" class="btn btn-secondary">
          <i class="bi bi-arrow-clockwise"></i> Actualiser
        </button>
      </div>
      <div class="col-auto">
        <button
          @click="$router.push({ name: 'attendances-create' })"
          class="btn btn-primary"
        >
          <i class="bi bi-plus-square"></i>
          Créer
        </button>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-4">
        <label>Mois</label>
        <input type="month" v-model="salaryMonth" class="form-control" />
      </div>
      <div class="col-md-4 d-flex align-items-end">
        <button @click="printAllSalarySlips" class="btn btn-success">
          <i class="bi bi-printer"></i> Imprimer toutes les fiches de salaire
        </button>
      </div>
    </div>
    <br />
    <div class="row mb-3">
      <div class="col-md-3">
        <label>Employé</label>
        <select
          v-model="filters.employee_reference"
          class="form-select"
          @change="applyFilters"
        >
          <option value="">Tous</option>
          <option
            v-for="employee in employees"
            :key="employee.reference"
            :value="employee.reference"
          >
            {{ employee.fullName }}
          </option>
        </select>
      </div>
      <div class="col-md-3">
        <label>Date début</label>
        <input
          type="date"
          v-model="filters.startDate"
          class="form-control"
          @change="applyFilters"
        />
      </div>
      <div class="col-md-3">
        <label>Date fin</label>
        <input
          type="date"
          v-model="filters.endDate"
          class="form-control"
          @change="applyFilters"
        />
      </div>
      <div class="col-md-3">
        <label>Statut</label>
        <select
          v-model="filters.status"
          class="form-select"
          @change="applyFilters"
        >
          <option value="">Tous</option>
          <option value="present">Présent</option>
          <option value="absent">Absent</option>
          <option value="late">En retard</option>
          <option value="leave">Congé</option>
        </select>
      </div>
    </div>
    <br />
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th scope="col">Nº</th>
          <th scope="col">Référence</th>
          <th scope="col">Employé</th>
          <th scope="col">Date</th>
          <th scope="col">Statut</th>
          <th scope="col">Créé par</th>
          <th scope="col">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(attendance, index) in attendances" :key="index++">
          <td>{{ index }}</td>
          <td class="p-0 m-0">{{ attendance.reference }}</td>
          <td>{{ attendance.employeeFullName }}</td>
          <td>{{ formatDate(attendance.date) }}</td>
          <td>
            <span
              :class="{
                'badge bg-success': attendance.status === 'present',
                'badge bg-danger': attendance.status === 'absent',
                'badge bg-warning': attendance.status === 'late',
                'badge bg-info': attendance.status === 'leave',
              }"
            >
              {{ getStatusLabel(attendance.status) }}
            </span>
          </td>
          <td>{{ attendance.userFullName }}</td>
          <td class="d-flex gap-2">
            <button
              @click="
                $router.push({
                  name: 'attendances-edit',
                  params: { reference: attendance.reference },
                })
              "
              class="btn btn-sm btn-primary"
            >
              <i class="bi bi-pencil"></i> Modifier
            </button>
            <button
              @click="deleteAttendance(attendance.reference)"
              class="btn btn-sm btn-danger"
            >
              <i class="bi bi-trash"></i> Supprimer
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    const now = new Date();
    const currentMonth = `${now.getFullYear()}-${String(
      now.getMonth() + 1
    ).padStart(2, "0")}`;
    return {
      filters: {
        employee_reference: "",
        startDate: "",
        endDate: "",
        status: "",
      },
      salaryMonth: currentMonth,
    };
  },
  computed: {
    ...mapGetters("attendance", {
      attendances: "getAll",
    }),
    ...mapGetters("employee", {
      employees: "getAll",
    }),
  },
  mounted() {
    this.$store.dispatch("attendance/getAll");
    this.$store.dispatch("employee/getAll");
  },
  methods: {
    refresh() {
      this.$store.dispatch("attendance/getAll");
    },
    applyFilters() {
      this.$store.dispatch("attendance/filter", this.filters);
    },
    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleDateString("fr-FR");
    },
    getStatusLabel(status) {
      const labels = {
        present: "Présent",
        absent: "Absent",
        late: "En retard",
        leave: "Congé",
      };
      return labels[status] || status;
    },
    async deleteAttendance(reference) {
      if (confirm("Êtes-vous sûr de vouloir supprimer cette présence ?")) {
        await this.$store.dispatch("attendance/destroy", reference);
      }
    },
    async printAllSalarySlips() {
      if (!this.salaryMonth) {
        this.$toasted.show("Veuillez sélectionner un mois", {
          type: "error",
        });
        return;
      }
      const [year, month] = this.salaryMonth.split("-");
      await this.$store.dispatch("attendance/printAllSalarySlips", {
        month,
        year,
      });
    },
  },
};
</script>
